import React from "react";
import ServiceImg from "../../common/images/services.png";
import our from "../../common/images/Our.png";
const HeroSection = () => {
  return (
    <section className="flex flex-col  max-w-[1280px] mx-auto md:flex-row  justify-between px-5 md:px-10 md:pb-10 pb-5  bg-white">
      {/* Left Side */}
      <div className="md:w-1/2 ">
        <img src={our} alt="Our Img" className="h-22 w-16 py-2" />

        <div className="flex items-center gap-5">
          <p className="text-black uppercase small:text-[22px] text-[16px] tracking-widest font-medium">
            Services
          </p>

          <p className="h-[3px] w-[30%] bg-[#FFC400]"></p>
        </div>
        <h1 className="small:text-4xl text-3xl md:text-5xl font-bold text-[#095C9D] leading-tight">
          <span className="block sm:inline">
            Innovative <span className="text-[#FFC400]">Solutions</span>
          </span>
          <span className="block">Tailored to Your</span>
          <span className="block sm:inline">Business</span>
        </h1>

        <p className="text-gray-600 mt-4 text-lg">
          At Binary Ops, we specialize in building smart, scalable, and secure
          digital solutions. Our team of experts combines creativity with
          technical excellence to deliver custom software and web solutions that
          drive business growth and efficiency.
        </p>
      </div>

      {/* Right Side */}
      <div className=" md:w-1/2  bg-[#F7F7F7] flex items-center justify-center mt-10 md:mt-0">
        {/* Center Icon */}
        <img src={ServiceImg} alt="service banner" className="size-[80%]" />
      </div>
    </section>
  );
};

export default HeroSection;
